import { useEffect, useRef } from "react";

/**
 * Measures the fixed site header and publishes its height as the
 * `--site-hdr` custom property so `.hero-fit` sections can fill the
 * remaining viewport exactly.
 */
export function useHeaderOffset<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const apply = () => {
      document.documentElement.style.setProperty(
        "--site-hdr",
        `${Math.round(el.getBoundingClientRect().height)}px`,
      );
    };

    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    window.addEventListener("resize", apply);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, []);

  return ref;
}
